import { oc } from '@orpc/contract';
import { refreshInputSchema, tokensOutputSchema } from '../schemas/auth.schemas.js';
export const refreshTokenContract = oc
    .route({
    method: 'POST',
    path: '/auth/refresh',
    tags: ['Auth'],
    summary: 'Exchange a valid refresh token for a fresh access/refresh token pair',
})
    .input(refreshInputSchema)
    .output(tokensOutputSchema);
//# sourceMappingURL=refresh-token.contract.js.map